import { render, staticRenderFns } from "./A4Settings.vue?vue&type=template&id=99d1c0dc&scoped=true"
import script from "./A4Settings.vue?vue&type=script&lang=js"
export * from "./A4Settings.vue?vue&type=script&lang=js"
import style0 from "./A4Settings.vue?vue&type=style&index=0&id=99d1c0dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d1c0dc",
  null
  
)

export default component.exports